import DateTools from 'utils/dates/dateTools'
import Config from 'utils/config'


const getDataFromIndicators = data => {
  return data.items.map(indicator => {
    let relationships = {
      sexMale: '',
      sexFemale: '',
      sexTotal: '',
      exist: false
    }
    if (indicator.meta.relationships) {
      indicator.meta.relationships.forEach(item => {
        switch (item.type) {
        case 'sex-male':
          relationships.sexMale = item.related_id
          break
        case 'sex-female':
          relationships.sexFemale = item.related_id
          break
        case 'sex-total':
          relationships.sexTotal = item.related_id
          break
        default:
          break
        }
      })
    }

    if (relationships.sexMale && relationships.sexFemale) relationships.exist = true

    return {
      id: indicator.id,
      name: indicator.name,
      unit: indicator.unit,
      lastUpdated: indicator.last_refreshed_on,
      dataSource: indicator.data_source,
      relationships: relationships,
      rankOrdering: indicator.rank_ordering,
      desc: indicator.description,
      note: indicator.note
    }
  })
}

const getDataFromSingleIndicator = data => {
  let relationships = {
    sexMale: '',
    sexFemale: '',
    sexTotal: '',
    exist: false
  }
  if (data.meta.relationships) {
    relationships.exist = true
    data.meta.relationships.forEach(item => {
      switch (item.type) {
      case 'sex-male':
        relationships.sexMale = item.related_id
        break
      case 'sex-female':
        relationships.sexFemale = item.related_id
        break
      case 'sex-total':
        relationships.sexTotal = item.related_id
        break
      default:
        break
      }
    })
  }
  return {
    id: data.id,
    name: data.name,
    unit: data.unit,
    lastUpdated: data.last_refreshed_on,
    relationships: relationships,
    rankOrdering: data.rank_ordering
  }
}

const getIndicatorsFromLevel = dimension => {
  dimension = Number(dimension)
  if ( dimension < Config.getConfig().panel_text.length ) {
    // convert to old format
    let subdimensions = Config.getConfig().panel_text[ dimension ][ "indicators" ];
    return subdimensions.map( sd => sd[ "indicators" ] );
  } else {
    return [];
  }
}

const getIndicatorEvolutionData = (data) => {
  let indicatorEvolutionData = data.map(item => {
    let itemData = {
      value: item.value,
      year: DateTools.getYearFromDateString(item.time)
    }
    return itemData
  })
  return indicatorEvolutionData
}

const getMaxAndMinYearFromIndicator = indicatorEvolutionData => {
  let min = indicatorEvolutionData[0].year
  let max = indicatorEvolutionData[0].year

  indicatorEvolutionData.forEach(item => {
    if (item.year < min) min = item.year
    if (item.year > max) max = item.year
  })

  return { min, max };
}

const getLevelFromIndicator = indicator => {
  let level
  for (let i = 1; i < 4; i++) {
    let indicators = []
    if (i === 3) {
      let indicatorsByGroup = getIndicatorsFromLevel(i)
      indicatorsByGroup.forEach(item => (indicators = indicators.concat(item)))
    } else {
      indicators = getIndicatorsFromLevel(i)
    }
    if (indicators.filter(item => item === indicator).length > 0) {
      level = i
      break
    }
  }
  return level
}

const getDimensionFromIndicator = indicator => {
  let panel = Config.getConfig().panel_text;

  for ( let dimension = 0; dimension < panel.length; dimension++ ) {
    if ( getIndicatorsFromLevel( dimension ).flat( 4 ).indexOf( indicator ) >= 0 ) {
      return dimension;
    }
  }

  return null;
}

const getIndicatorIndexInPanel = indicator => {
  let panel = Config.getConfig().panel_text;

  for ( let i = 0; i < panel.length; i++ ) {
    for ( let j = 0; j < panel[i].indicators.length; j++ ) {
      if ( panel[i].indicators[j].indicators.indexOf( indicator ) >= 0 ) {
        return [i, j];
      }
    }
  }

  return null;
}

const getIndicatorNameFromId = ({ indicatorsData, id }) => {
  let name
  for (let i = 0; i < indicatorsData.length; i++) {
    if (Number(indicatorsData[i].id) === Number(id)) {
      name = indicatorsData[i].name
      break
    }
  }

  return cleanIndicatorName(name);
}

const cleanIndicatorName = (name) => {
  const regex = /\[[^\]]*\]/gm;
  return name.replace(regex, '').trim();
}

const cleanIndicatorUnit = (unit) => {
  const regex = /\(EU27_2020\)/gm;
  return unit.replace(regex, '').trim();
}

const formatValuePartTranslate = (part) => {
  if ( part.type === 'decimal' ) {
    return ".";
  } else if ( part.type === 'group' ) {
    return "\u202F";
  } else {
    return part.value;
  }
}

const formatValue = (n, unit, minFractionDigits = 0) => {
  let fractionDigits = (unit.indexOf('%') >= 0) ? (minFractionDigits + 1) : minFractionDigits;
  let formatter = new Intl.NumberFormat('en-US', { maximumFractionDigits: fractionDigits });

  let parts = formatter.formatToParts( n );
  return parts.map( formatValuePartTranslate ).join( "" );
}

const indicatorTools = {
  getDataFromIndicators,
  getDataFromSingleIndicator,
  getIndicatorsFromLevel,
  getIndicatorEvolutionData,
  getMaxAndMinYearFromIndicator,
  getLevelFromIndicator,
  getIndicatorNameFromId,
  getDimensionFromIndicator,
  getIndicatorIndexInPanel,
  cleanIndicatorName,
  cleanIndicatorUnit,
  formatValue
}

export default indicatorTools



// WEBPACK FOOTER //
// ./src/utils/indicators/indicatorTools.js